import Debug from 'utils/debug';

import Supports from 'bloko/common/supports';

type DebugHandler = (...args: unknown[]) => void;

/**
 * Модуль регистрирует обработчик для отладочной утилиты
 * служит для кроссбраузерного отображения подробного объекта Error в консоли с кликабельным стектрейсом. <br>
 *
 * Имя обработчика - "error", Уровень логирования - PRODUCTION
 *
 * @example
 * Debug = require('utils/debug');
 * Debug.log('error', new Error('Ошибка!'))
 *
 * @param {...Error} args Объект ошибки для вывода
 * @type {Function}
 * @exports utils/debug/Error
 */
const handler: DebugHandler = (...args) => {
    args.forEach((error, index) => {
        if (error instanceof Error) {
            // В вебкитах стек выводится не от ошибки, а от места где произошел throw,
            // по-этому заменяем выстрел throw на вывод error.stack.
            if (Supports.webkit() && error.stack) {
                // В хроме <43 error.stack должен быть выброшен в отдельном console.error
                console.error(error.stack);
            }
            args.splice(index, 1);
        }
    });
    if (args.length === 0) {
        return;
    }
    console.error(...args);
};
Debug.registerLog('error', Debug.viewMods.PRODUCTION, handler);
